module.exports = __webpack_public_path__ + "static/img/password.8e45c9ce.svg";